<template lang="pug">
	.text-replace-container(v-if="showed && isAllowedToShow" :style="containerStyle")
		.text-replace-btn
			i.fa.fa-pencil
		.text-replace-hint Double-click to edit text
</template>

<script>
	import Screen from './../../mixins/screen';

	import { Elements } from '../../services/Elements';
	import { Layout } from '../../services/Layout';

	// Иконка-карандаш по центру важного текста (options.importantElement) при наведении на него в превью.
	// Сама иконка не перехватывает мышь (pointer-events: none) - по двойному нажатию на элемент iframe присылает StartInlineTextEdit и открывается InlineTextEdit.
	export default {
		name: 'InlineTextReplace',
		mixins: [Screen],
		screen: {
			events: {
				"IFrame Data:HitElement": function(data) {

					let elementKey = data ? `${data.screenCodename}/${data.elementCodename}` : null;

					// Пока указатель остаётся над редактируемым текстом, кнопку не показываем, чтобы она не перекрывала текст
					if (elementKey !== this.editingElementKey) this.editingElementKey = null;

					if (data && !this.editingElementKey && Elements.getImportantElement(data.screenCodename, data.elementCodename)?.type === 'text') this.showButton(data);
					else this.hideButton();

				},
				"IFrame Data:StartInlineTextEdit": function(data) {

					this.editingElementKey = `${data.screenCodename}/${data.elementCodename}`;
					this.hideButton();

				},
				// После закрытия редактора текста кнопку снова можно показывать
				"InlineTextEdit Hided": function() {

					this.editingElementKey = null;

				},
				"Preview Zoom Changed,Preview Drag State Changed,Preview Size Changed,Layout Workspace Changed,Aside State Changed,Sub Aside State Changed": function() {

					if (this.showed) {

						this.$nextTick(() => {
							this.updatePosition();
						});

					}

				},
				"Selected Version Switched,Selected Creative Changed,Refresh Iframe,IFrame Data:AppScreensCreated": function() {

					this.hideButton();

				},
				"Settings Tab Changed,Aside State Changed": function() {

					this.update();

				},
				"Element Changed: [options]": function() {

					if (this.showed && !Elements.getImportantElement(this.screenCodename, this.elementCodename)) this.hideButton();

				}
			}
		},
		data() {
			return {
				isAllowedToShow: false,
				screenCodename: null,
				elementCodename: null,
				editingElementKey: null,
				lastIframeRelativeRect: null,
				position: {
					top: '0px',
					left: '0px'
				}
			};
		},
		computed: {
			containerStyle() {
				return {
					top: this.position.top,
					left: this.position.left
				};
			}
		},
		mounted() {

			this._onWindowResize = () => {

				if (this.showed) this.updatePosition();

			};

			window.addEventListener('resize', this._onWindowResize);

		},
		beforeDestroy() {

			if (this._onWindowResize) window.removeEventListener('resize', this._onWindowResize);

		},
		methods: {
			collectData() {

				// Как и кнопка замены ассета - не показываем на вкладке редактора элементов
				this.isAllowedToShow = !(Layout.asideOpened && Layout.settingsTabName === 'elements');

			},
			showButton(data) {

				this.screenCodename = data.screenCodename;
				this.elementCodename = data.elementCodename;
				this.lastIframeRelativeRect = data.rect;

				this.show();

				this.$nextTick(() => {

					this.updatePosition(data.rect);

				});

			},
			hideButton() {

				this.hide();

			},
			updatePosition(iframeRelativeRect) {

				if (!iframeRelativeRect) iframeRelativeRect = this.lastIframeRelativeRect;
				if (!iframeRelativeRect) return;
				this.lastIframeRelativeRect = iframeRelativeRect;

				let iframe = document.querySelector('.preview-frame iframe') || document.querySelector('iframe');
				let iframeRect = iframe ? iframe.getBoundingClientRect() : { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };

				let baseWidth = (iframeRelativeRect.windowWidth && iframeRelativeRect.windowWidth > 0)
					? iframeRelativeRect.windowWidth
					: (iframe ? (iframe.offsetWidth || parseFloat(iframe.getAttribute('width')) || iframe.clientWidth || 0) : 0);

				let baseHeight = (iframeRelativeRect.windowHeight && iframeRelativeRect.windowHeight > 0)
					? iframeRelativeRect.windowHeight
					: (iframe ? (iframe.offsetHeight || parseFloat(iframe.getAttribute('height')) || iframe.clientHeight || 0) : 0);

				let scaleX = (baseWidth > 0 && iframeRect.width > 0) ? iframeRect.width / baseWidth : 1;
				let scaleY = (baseHeight > 0 && iframeRect.height > 0) ? iframeRect.height / baseHeight : 1;

				let screenRect = {
					top: iframeRect.top + iframeRelativeRect.top * scaleY,
					left: iframeRect.left + iframeRelativeRect.left * scaleX,
					width: iframeRelativeRect.width * scaleX,
					height: iframeRelativeRect.height * scaleY
				};

				let containerWidth = this.$el?.offsetWidth || 40;
				let containerHeight = this.$el?.offsetHeight || 60;

				// Кнопка размещается по центру элемента
				let top = screenRect.top + (screenRect.height - containerHeight) / 2;
				let left = screenRect.left + (screenRect.width - containerWidth) / 2;

				this.position.top = `${top}px`;
				this.position.left = `${left}px`;

			}
		}
	};
</script>

<style lang="sass">

	.text-replace-container
		position: fixed
		z-index: 100000
		display: flex
		flex-direction: column
		align-items: center
		pointer-events: none

		.text-replace-btn
			width: 40px
			height: 40px
			display: flex
			align-items: center
			justify-content: center
			//background: rgba(0, 0, 0, 0.5)
			color: #d4af37
			//border: 2px solid #d4af37
			border-radius: 50%
			font-size: 18px
			box-sizing: border-box
			text-shadow: 0 0 15px rgba(0, 0, 0, 0.9), 0 0 15px rgba(0, 0, 0, 0.9), 0 0 15px rgba(0, 0, 0, 0.9), 0 0 15px rgba(0, 0, 0, 0.9), 0 0 15px rgba(0, 0, 0, 0.9)

		.text-replace-hint
			margin-top: 4px
			padding: 2px 6px
			background: rgba(0, 0, 0, 0.6)
			color: #d4af37
			border-radius: 4px
			font-size: 11px
			white-space: nowrap

</style>
